import MemberHome from '@/components/#public/member/MemberHome'

import HomePage from '@/components/#public/home/HomePage'
import Payment from '@/components/#public/member/MemberPayment'

export default [
    {
        path: '/',
        component: HomePage

    },
    {
        path: '/reglas-publicacion',
        component: () => import('@/views/ReglasPublicacion.vue')
    },
    {
        path: '/terminos-condiciones',
        component: () => import('@/views/TerminosCondiciones.vue')
    },
     {
        path: '/atencion-clientes',
        component: () => import('@/views/AtencionCliente.vue')
    },
    {
        path: '/aviso-privacidad',
        component: () => import('@/views/AvisoPrivacidad.vue')
    },
    {
        path: '/cv',
        component: () => import('@/views/MiCV.vue')
    },
    {
        path: '/empresas',
        component: () => import('@/views/Empresas.vue')
    },
    {
      path: '/cursos',
      name: 'cursos-home',
      component: () => import('@/views/Cursos.vue')
    },
    {
        path: '/blog',
        name: 'blog-home',
        component: () => import('@/views/Blog.vue')
      },
    {
        path: '/memberships',
        component: MemberHome,
        meta:{
            requiresAuth: true,
            requiresEnterprise: true
        }
    },
    {
        path: '/payment',
        component: Payment,
        meta:{
            requiresAuth: true,
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/home.js